import React, { useEffect, useRef, useState } from 'react';
import { getHighlight } from '../../../../apis/Ambition';
import { PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';

export const AmbitionAndStatus = () => {

  const [text, setText] = useState();
  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: "leader_letter",
      setValue: setText
    });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ambitionandstatus" ref={ref}>
      <h2 style={{ fontSize: fontReport(width,PRINT_WIDTH,51/PRINT_WIDTH,"px") }}>Ambition & Status</h2>
      <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,28/PRINT_WIDTH,"px") }}>A letter from the CEO</h5>
      <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px") }}>{text}</h5>
    </div>
  );
};
